import { DetectPlatformService } from '@alliance/shared/utils'
import { Directive, EventEmitter, Output, ElementRef, Inject, OnInit, OnDestroy, Input } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { from, fromEvent, Subject } from 'rxjs'
import { debounceTime, mergeMap, takeUntil } from 'rxjs/operators'

@Directive({
  selector: '[allianceInfiniteScrolling]'
})
export class InfiniteScrollingDirective implements OnInit, OnDestroy {
  @Output() public scrollPosition = new EventEmitter<Event>()
  @Input() public offset = 0
  @Input() public debounceTime = 300
  private destroy$ = new Subject<void>()

  public constructor(@Inject(DOCUMENT) private document: Document, public el: ElementRef<HTMLElement>, public platform: DetectPlatformService) {}

  public ngOnInit(): void {
    if (this.platform.isServer) {
      return
    }

    if (this.document.defaultView) {
      const events: Array<{ target: EventTarget; event: string }> = [
        { target: this.document.defaultView, event: 'scroll' },
        {
          target: this.el.nativeElement,
          event: 'scroll'
        }
      ]

      from(events)
        .pipe(
          mergeMap(({ target, event }) => fromEvent(target, event)),
          takeUntil(this.destroy$),
          debounceTime(this.debounceTime)
        )
        .subscribe((event: Event) => {
          if (event.target === this.document && (this.document.defaultView?.innerHeight || 0) + (this.document.defaultView?.scrollY || 0) + (this.offset ?? 0) >= this.document.body.offsetHeight) {
            this.scrollPosition.emit(event)
          }

          if (event.target !== this.document && this.el.nativeElement.offsetHeight + this.el.nativeElement.scrollTop >= this.el.nativeElement.scrollHeight) {
            this.scrollPosition.emit(event)
          }
        })
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
